function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2754 80H80.0911V8.11743C80.0911 3.67316 76.5172 0 71.9771 0H62.2184L52.2678 5.79771V20.2888L66.2754 11.8834V80Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9965 80H53.8121V25.0242C53.8121 19.8056 49.6591 15.5565 44.3447 15.5565H35.9394L26.1808 21.5462V35.8453L39.9965 27.5359V80Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9117 80H27.8234V41.547C27.8234 36.0373 23.3792 31.7882 18.1639 31.7882H9.85464L0 37.6819V51.981L13.9117 43.6716V80Z",
  fill: "white"
});
var SvgPrimeiraMao = function SvgPrimeiraMao(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimeiraMao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primeira_mao.5f1adb0b.svg";
export { ForwardRef as ReactComponent };